import { BlotterDensity, BlotterTable, Card, useBlotterObservables, useBlotterTable } from '@talos/kyoko';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import type { PreTradeResponseData } from '../../../redux/preTradeApi';
import { getPreTradePredictionRows } from './getPreTradePredictionRows';
import { usePreTradePredictionColumns } from './usePreTradePredictionColumns';

interface PreTradePredictionsProps {
  scenario?: PreTradeResponseData;
}

export function PreTradePredictions({ scenario }: PreTradePredictionsProps) {
  const theme = useTheme();
  const columns = usePreTradePredictionColumns();

  const data = useMemo(() => getPreTradePredictionRows(scenario), [scenario]);
  const { dataObservable, errorObservable } = useBlotterObservables({ data });

  const blotterTable = useBlotterTable({
    dataObservable,
    errorObservable,
    density: BlotterDensity.Compact,
    columns,
    rowID: 'name',
    gridOptions: {
      domLayout: 'autoHeight',
      getRowStyle: () => {
        return { background: theme.backgroundCard, borderBottom: 'none' };
      },
    },
  });

  return (
    <Card title="Trade Predictions" data-testid="trade-predictions-card" p="spacing12">
      <BlotterTable {...blotterTable} headerBackground={theme.backgroundCard} hideHeaderBorder />
    </Card>
  );
}
